import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EventTemplateResponse } from '../../../types/EventTemplate';

type UseGetAllEventTemplateParams = {
  page?: number;
  per_page?: number;
  search?: string,
  filters?: {
    archived?: boolean;
    is_parent?: boolean[];
  };
};

export type UseGetAllEventTemplateProps = {
  params?: UseGetAllEventTemplateParams;
  enabled?: boolean;
};

export const fetchAllEventTemplate = async ({ params }: UseGetAllEventTemplateProps) => {
  const response = await CustomAxios.get<EventTemplateResponse>(`event_templates`, { params });
  const { data } = response;
  return data;
};

export function useGetAllEventTemplate({ params, enabled = true }: UseGetAllEventTemplateProps) {
  const queryKey: any = [queryKeys.allEventTemplates, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllEventTemplate({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
